import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { LeadService } from 'src/app/services/lead.service';

@Component({
    selector: 'app-lead',
    templateUrl: './lead.component.html',
    styleUrls: ['./lead.component.css'],
    standalone: false
})
export class LeadComponent implements OnInit {
  total = 0;
  loading = true;
  search; //String que irá guardar o que o usuário quer pesquisar
  isVisibleCancelFiltro = false;
  pageSize = 10;
  pageIndex = 1;

  leads = [];

  visibilidadeModalExportacaoLead = false;

  expandSet = new Set<number>();

  constructor(
    private message: NzMessageService,
    private route: ActivatedRoute,
    private router: Router,
    private leadService: LeadService
  ) {
    
  }

  ngOnInit(): void {
  }

  onExpandChange(id: number, checked: boolean): void {
    if (checked) {
      this.expandSet.add(id);
    } else {
      this.expandSet.delete(id);
    }
  }

  ativar(id: any) {
    let idLoading = this.message.loading('Ativando usuário...').messageId;
    this.leadService.ativar(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Ativação realizada com sucesso!');
      this.recarregar();
    }, () => {
      this.loading = false;
      this.message.remove(idLoading);
      this.message.error('Houve uma falha ao inativar o usuário, tente novamente mais tarde!');
    });
  }

  excluir(id: any) {
    let idLoading = this.message.loading('Excluindo usuário...').messageId;
    this.leadService.excluir(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Exclusão realizada com sucesso!');
      this.recarregar();
    }, () => {
      this.loading = false;
      this.message.remove(idLoading);
      this.message.error('Houve uma falha ao excluir o usuário, tente novamente mais tarde!');
    });
  }

  recarregar(){
    this.loading = true;
    this.leadService.all(this.pageIndex, this.search).subscribe((m: any) => {
      this.leads = m.data.leads.data;
      this.total = m.data.leads.total;
      this.pageSize = m.data.leads.per_page;
      this.loading = false;
    });
  }

  inativar(id: any) {

    let idLoading = this.message.loading('Inativando usuário...').messageId;
    this.leadService.inativar(id).subscribe((i: any) => {
      this.message.remove(idLoading);
      this.message.success('Inativação realizada com sucesso!');
      this.recarregar();
    }, () => {
      this.loading = false;
      this.message.remove(idLoading);
      this.message.error('Houve uma falha ao ativar o usuário, tente novamente mais tarde!');
    });

  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.leadService.all(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.leads = m.data.leads.data;
      this.total = m.data.leads.total;
      this.pageSize = m.data.leads.per_page;
      this.loading = false;
    });
  }

  removerFiltro() {
    this.search = '';
    this.searchUsuario();
    this.isVisibleCancelFiltro = false;
  }

  searchUsuario() {
    if (this.search !== undefined) {
      this.isVisibleCancelFiltro = true;
      this.loading = true;    
      this.pageIndex = 1
      this.recarregar();
    } else {
      this.message.warning("Digite a sua pesquisa para continuar.");
    }

  }

  abrirModalExportacaoLead(){
    this.visibilidadeModalExportacaoLead = true;
  }

  fecharModalExportacaoLead(){
    this.visibilidadeModalExportacaoLead = false;
  }
}
